import Ueberschriften from './Ueberschriften'
import Player from './Player'
import { useEffect, useState } from 'react';
import Select from 'react-bootstrap/FormSelect';
import Table from 'react-bootstrap/Table';
import Label from 'react-bootstrap/FormLabel';
import Button from 'react-bootstrap/Button';

const Blatt = (props) => {
    const [ number, setNumber ] = useState(0)
    const [ players, setPlayers ] = useState([])
    const [ started, setStarted ] = useState(false)
    

    const setPlayerPoints = (i, points) => {
        console.log("setPlayerPoints")
        var tmpPlayers = []
        for (var j=0;j<players.length;j++) {
            tmpPlayers.push(players[j])
            if(j===i) {
                tmpPlayers[j].points = points
            }
        }
        tmpPlayers.sort((a,b) => {
            return parseInt(b.points) - parseInt(a.points)
        })
        for(var k=0;k<tmpPlayers.length;k++) {
            tmpPlayers[k].platzierung = k+1
        }
        var updatedPlayers = []
        for (var z=0;z<players.length;z++) {
            updatedPlayers.push(players[z])
        }
        for(var x=0;x<tmpPlayers.length;x++) {
            for(var y=0;y<updatedPlayers.length;y++) {
                if (tmpPlayers[x].name === updatedPlayers[y].name) {
                    updatedPlayers[y].platzierung = tmpPlayers[x].platzierung
                }
            }
        }
        setPlayers(updatedPlayers)
    }
    const setPlayerName = (i, name) => {
        console.log("setPlayerName")
        var tmpPlayers = []
        for (var j=0;j<players.length;j++) {
            tmpPlayers.push(players[j])
            if(i===j) {
                tmpPlayers[j].name = name
            }
        }
        setPlayers(tmpPlayers)
    }

    useEffect(() => {

    },[players])
    
    useEffect(() => {
        console.log("useEffectNumber")
        var tmpPlayers = []
        for (var i=0;i<number;i++) {
            tmpPlayers.push({name: "", platzierung: 0, points: 0})
        }
        setPlayers(tmpPlayers)
    },[number])    

    return (
        <div>
            { console.log("return render")}
            { started===false && <div><Label>Number of Players</Label><Select style={{display: "inline-block",width: "100px",marginLeft: "10px", marginRight: "10px"}} className='text-center' value={number} onChange={e => {setNumber(e.target.value);props.setNumber(e.target.value)}}>
                <option>0</option>
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
            </Select><Button style={{width: "100px", marginTop: "-6px"}} onClick={() => setStarted(true)}>Start</Button></div>
            }
            {started===true && <Table>
                <tbody>
                    <tr>
                        <td><Ueberschriften /></td>
                        {
                            players.length>0 && players.map((player,i) => {
                                console.log("rerender")
                                console.log(i)
                                return <td key={"player"+i}><Player playerId={i} onNameChange={setPlayerName} onPointsChange={setPlayerPoints} platzierung={player.platzierung} /></td>
                            })
                        }
                    </tr>
                </tbody>
            </Table>}
        </div>
    )
}

export default Blatt;